import Adopt from "pages/Adopt";
import DogDetail from "pages/DogDetail";
import DogListView from "pages/DogListView";
import Donate from "pages/Donate";
import P4P404Page from "pages/P4P404Page";
import React from "react";
import { Routes, Route } from "react-router";


const AppRouter: React.FC = () => (
    <Routes>
        <Route path="/" Component={DogListView} />
        <Route path="/dog/detail/:id" Component={DogDetail} />
        <Route path="/donate" Component={Donate} />
        <Route path="/adopt" Component={Adopt} />
        <Route path="*" Component={P4P404Page} />
    </Routes>
);

export default AppRouter;